<template>
  <div class="container">
    <div class="row" v-if="!add_item">

      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">BIENES MUEBLES (SITUACIÓN ACTUAL)</legend>
        </div>
      </div>

      <div class="form-group col-12">
        <label class="control-label"> ¿ Tiene bienes muebles ? <b-button class="btn-popover" v-b-popover.hover.top="info.bienes"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de bienes declarados a nombre la pareja, dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. </div>
        </div>
        <div class="row">
          <legend>Bienes del declarante, pareja y/o dependientes económicos</legend>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="control-label">Tipo de bien <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_bien"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="tipos_mueble" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.tipo_bien_id">
              <el-option v-for="option in tipos_mueble" class="select-default" :value="option.id" :label="option.valor" :key="option.valor"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipos_mueble')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_bien_id == 6">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique_bien" v-validate="'required'" v-model="form_item.especifique_bien" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique_bien')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Descripción general del bien <b-button class="btn-popover" v-b-popover.hover.top="info.descripcion"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="descripcion" v-validate="'required'" v-model="form_item.descripcion" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('descripcion')}}</small>
          </div>

          <div class="form-group col-6">
            <label class="control-label">Titular del bien <b-button class="btn-popover" v-b-popover.hover.top="info.titular"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable class="select-default" placeholder="Seleccione una opción" name="titular" v-validate="'required'" v-model="form_item.titular_id">
              <el-option v-for="option in titular_adeudo" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('titular')}}</small>
          </div>

          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Tercero <b-button class="btn-popover" v-b-popover.hover.top="info.tercero"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="1">Persona física</p-radio>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('tercero')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Nombre del tercero o terceros <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_tercero"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_tercero" v-validate="'required'" v-model="form_item.nombre_tercero" placeholder="Nombre o razón social">
            <small class="text-danger">{{ errors.first('nombre_tercero')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">RFC del tercero <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_tercero"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_tercero" v-validate="'uppercase|max:13'" v-model="form_item.rfc_tercero" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_tercero')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Transmisor <b-button class="btn-popover" v-b-popover.hover.top="info.transmisor"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="transmisor" class="d-inline-block" v-validate="'required'" v-model="form_item.transmisor" label="1">Persona física</p-radio>
            <p-radio name="transmisor" class="d-inline-block" v-validate="'required'" v-model="form_item.transmisor" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('transmisor')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre o razón social del transmisor <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_transmisor"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_transmisor" v-validate="'required'" v-model="form_item.nombre_transmisor" placeholder="Nombre o razón social">
            <small class="text-danger">{{ errors.first('nombre_transmisor')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC del transmisor <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_transmisor"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_transmisor" v-validate="'uppercase|max:13'" v-model="form_item.rfc_transmisor" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_transmisor')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Relación del transmisor de la propiedad con el titular <b-button class="btn-popover" v-b-popover.hover.top="info.relacion"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="relacion" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.relacion_persona_adquirio_id">
              <el-option v-for="option in transmisores" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('relacion')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.relacion_persona_adquirio_id == 20">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="relacion_especificar" v-validate="'required'" v-model="form_item.relacion_especificar" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('relacion_especificar')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Forma de adquisición <b-button class="btn-popover" v-b-popover.hover.top="info.forma_adquisicion"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="forma_adquisicion" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.forma_adquisicion_id">
              <el-option v-for="option in adquisiciones" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('forma_adquisicion')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Forma de pago <b-button class="btn-popover" v-b-popover.hover.top="info.forma_pago"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="forma_pago" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.forma_pago">
              <el-option v-for="option in pagos" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('forma_pago')}}</small>
          </div>
          <div class="form-group col-6 ">
            <label class="control-label">Valor de adquisición del bien mueble <b-button class="btn-popover" v-b-popover.hover.top="info.precio_adquisicion_valor+' '+info.precio_adquisicion_moneda_id"><i class="far fa-question-circle"></i></b-button></label>
            <div class="customCurrency">
              <b-input-group size="sm" :prepend="getSigno">
                <b-form-input name="precio_adquisicion_valor" v-validate="'required|min:1'" type="number" min="0" class="text-right" v-model="form_item.precio_adquisicion_valor" placeholder="0" @keyup.native="isNumber" />
                <!-- @keyup.native="isNumber($event,form_item.precio_adquisicion_valor)" -->
                <b-dropdown right split :text="getCodigoMoneda" v-model="form_item.precio_adquisicion_moneda_id">
                  <b-dropdown-item v-for="option in monedas" :key="option.codigo" :value="option.codigo" @click="form_item.precio_adquisicion_moneda_id = option.id">{{option.moneda}}</b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </div>
            <small class="text-danger">{{ errors.first('precio_adquisicion_valor')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Fecha de Adquisición del bien mueble <b-button class="btn-popover" v-b-popover.hover.top="info.fecha_adquisicion"><i class="far fa-question-circle"></i></b-button></label>
            <div class="form-group">
              <el-date-picker name="fecha_adquisicion" v-validate="'required|min:1'" type="date" v-model="form_item.fecha_adquisicion" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha"></el-date-picker>
            </div>
            <small class="text-danger">{{ errors.first('fecha_adquisicion')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">En caso de baja del mueble incluir motivo <b-button class="btn-popover" v-b-popover.hover.top="info.motivo_baja"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="motivo_baja" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.motivo_baja">
              <el-option v-for="option in bajas_inmueble" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
          </div>
          <div class="form-group col-6" v-if="form_item.motivo_baja == 4">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique_baja" v-validate="'required'" v-model="form_item.especifique_baja" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique_baja')}}</small>
          </div>
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="!edit_item ">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.titular_id="{ item }">
                <div>{{filterCatalog(item.titular_id,titular_adeudo)}}</div>
              </template>
              <template v-slot:item.tipo_bien_id="{ item }">
                <div>{{filterCatalog(item.tipo_bien_id,tipos_mueble)}}</div>
              </template>
              <template v-slot:item.motivo_baja="{ item }">
                <div>{{filterCatalog(item.motivo_baja,bajas_inmueble)}}</div>
              </template>

            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        ip_id: null,
        add_item: false,
        edit_item: null,
        bandera: '0',
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Dado de baja',
          value: 'motivo_baja',
          align: 'center',
        }, {
          text: 'Tipo de bien',
          value: 'tipo_bien_id',
          align: 'center',
        }, {
          text: 'Titular del bien',
          value: 'titular_id',
          align: 'center',
        }, {
          text: 'Descripción general del bien',
          value: 'descripcion',
          align: 'center',
        }, {
          text: 'Aclaraciones / Observaciones',
          value: 'observaciones',
          align: 'center',
        }, ],
        info: {
          bienes: 'Para la declaración de inicio reportar la situación de los vehículos a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de los vehículos del año inmediato anterior. Para la declaración de conclusión reportar la situación de los vehículos a la fecha de conclusión del empleo, cargo o comisión.',
          tipo_bien: 'Seleccionar el tipo de vehículo del listado desplegable: automóvil/motocicleta, aeronave, barco/yate, otro, especifique.',
          titular: 'Seleccionar alguna de las opciones del catálogo desplegable.',
          tercero: 'En caso de copropiedad con un tercero, seleccionar si es persona física o persona moral.',
          nombre_tercero: 'En caso de copropiedad, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
          rfc_tercero: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
          transmisor: 'Seleccionar si es persona física o persona moral.',
          nombre_transmisor: 'Escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
          rfc_transmisor: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
          relacion: 'Elegir del catálogo qué relación tiene el titular del vehículo con el transmisor.',
          descripcion: 'Elegir la marca del catálogo desplegable.',
          forma_adquisicion: 'Seleccionar alguna de las opciones del catálogo.',
          forma_pago: 'Seleccionar la forma en que realizó el pago para adquirir el vehículo, en caso de que no haya pagado por el mismo, indicará no aplica.',
          precio_adquisicion_valor: 'Proporcionar el monto de adquisición, conforme al documento con el que se acredita la propiedad.',
          precio_adquisicion_moneda_id: 'Seleccionar la moneda relativa al valor de adquisición.',
          fecha_adquisicion: 'Señalar la fecha de adquisición del vehículo, conforme al documento con el que se acredita la propiedad.',
          motivo_baja: 'Elegir la razón por la cual se da de baja: venta, donación, siniestro, otro. Especifique.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },

    computed: {
      terceros() {
        if (this.form_item) {
          if (this.form_item.titular_id) {
            var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
            return arr.includes(this.form_item.titular_id);
          }
        }
        return false;
      },
      getSigno() {
        var signo = "$";
        var val = this.form_item.precio_adquisicion_moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      getCodigoMoneda() {
        var codigo = "MXN";
        var val = this.form_item.precio_adquisicion_moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo;
          }
        });
        return codigo;
      },

    },
    watch: {

    },
    methods: {

      showItem() {
        this.add_item = true;
        if (!this.form_item.pais_id) {
          //El id Mexico es 150
          this.form_item.pais_id = 150;

        }
        this.form_item.precio_adquisicion_moneda_id = 97;
        this.$validator.resume();
      },
      cancelEdit() {
        this.add_item = false;
        this.form_item = {};
        this.edit_item = false;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              //this.checkDomicilio();
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("bienes_muebles_no_registrados", this.form_item).then(
                response => {
                  this.StepOk("Guardado");
                  //if (this.edit_item === undefined || this.edit_item === null) {
                  if (!this.edit_item) {
                    this.table_list.unshift({
                      ...response.data.response
                    });
                  } else {
                    let index = this.table_list.map(u => {
                      return u.id;
                    }).indexOf(response.data.response.id);
                    this.table_list.splice(index, 1, response.data.response);
                  }
                  this.cancelEdit();
                }, error => {
                  this.StepError(error);
                });
            }
          } else {
            this.StepW("Hay campos sin completar");
            this.scrolling();
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = true;
        this.form_item = {
          ...item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("bienes_muebles_no_registrados/" + item.id).then(
              response => {
                let index = this.table_list.map(u => {
                  return u.id;
                }).indexOf(item.id);
                this.table_list.splice(index, 1);
                this.StepOk('Registro eliminado');
              }, error => {
                this.Err(error);
              });
          });
        }
      },
      checkDomicilio() {
        if (this.n_domicilio) {
          this.form_item.pais_id = this.n_domicilio.pais;
          this.form_item.entidad_federativa_id = this.n_domicilio.entidadF;
          this.form_item.municipio_id = this.n_domicilio.municipio;
          this.form_item.localidad_id = this.n_domicilio.localidad;
          this.form_item.cp = this.n_domicilio.cp;
          this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre;
          this.form_item.vialidad_tipo = this.n_domicilio.vialidad;
          this.form_item.numext = this.n_domicilio.ext;
          this.form_item.numint = this.n_domicilio.int;
          this.form_item.colonia = this.n_domicilio.colonia;
        }
      },

    },
    created() {
      this.ip_id = this.getKey('uid');
      this.$http.get("bienes_muebles_no_registrados/" + this.ip_id).then(
        response => {
          this.table_list = response.data.response;
          if (this.table_list) {
            if (this.table_list.length > 0) {
              this.bandera = '1';
            }
          }
        });
    },
    mounted() {
      this.checkCatalogs();
      this.form_item.pais_id = 150;
    },
  };

</script>
<style>
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
    -moz-appearance: textfield !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Activos/BienesMueblesNR.vue